import styled, { css } from 'styled-components';
import { getSizeInRem } from '../../methods/common.js';
import COLORS from '../../constants/colors.js';
import '../../constants/fonts.js';
import '../../constants/theme.js';
import '../../constants/files.js';
import '../../constants/color-variant.js';
import '../../constants/zIndexList.js';
import '../../mixins/style-mixins.js';
import '../../mixins/scrollbar.js';
import '../../mixins/cursor.js';
import { getCommonFontStyleMixin } from '../../mixins/font.js';

const StyledTextAreaInput = styled.textarea `
    font-size: 1rem;
    border: 2px solid ${COLORS.GREY_200};
    color: ${COLORS.GREY_1000};
    border-radius: 4px;
    padding: 0.8em;
    outline: none;
    width: ${({ width }) => (width ? getSizeInRem(width) : "100%")};
    resize: vertical;
    &:focus {
        border: 2px solid ${COLORS.BLUE};
    }

    &::placeholder {
        color: ${COLORS.GREY_400};
    }

    ${({ size }) => {
    switch (size) {
        case "sm":
            return css `
                    ${getCommonFontStyleMixin({ size })};
                `;
        default:
            return css ``;
    }
}};
`;

export { StyledTextAreaInput };
//# sourceMappingURL=TextArea.styles.js.map
